import { Component } from "../../core/Component";
import AgreementBox from "../agreementBox/agreementBox.component";
export class AgreementComponent extends Component {
  constructor($root, options) {
    super($root, options);
    this.options = options;
    // this.fieldId = options.id;
    this.messages = options.messages;
    this.submitSetting = options.submitSetting || submitSetting;
    this.type = options.type || "submit";
    // this.typeId = options.typeId;
    this.formId = options.formId;
    this.mode = options.mode;
    this.domain = options.domain;
    this.classes = options.submitSetting || "";
    this.useDesign = options.useDesign;
    // установка пользовательских классов оформления
    this.setUserClasses();
    this.hideSubmitButton = options.hideSubmitButton;
    this.agreementSettings = options.agreementSettings || 0;
    this.useAgreement = Object.keys(this.agreementSettings).length > 0;
    this.showCaption = options.showCaption;
    // this.showCaption = 1;
    this.captionLink = options.captionLink;
    this.device = options.device;
    this.agreementLabelEx = options.agreementLabelEx || "";
    this.require = options.required === 1;
    this.disabledClass = 0;
    this.id = `${this.submitSetting.name}_${options.formId}_${options.formIndex}`;
    //идентификаторы для галки с персональными и(или) специальными данными
    this.agreementInputId = `check-agreement_${options.formId}_${options.formIndex}`;
    this.agreementLabelId = `label_${options.formId}_${options.formIndex}`;
    //идентификаторы для галки с получением рекламных материалов
    this.adviseInputId = `check-advise_${options.formId}_${options.formIndex}`;
    this.adviseLabelId = `advice-label_${options.formId}_${options.formIndex}`;
    //идентификаторы для подписи к форме ('Cоздать форму. Создано в конструкторе Qform.io')
    this.qformLabelId = `qform-label_${options.formId}_${options.formIndex}`;
    this.qformLabelLinkId = `qform-label-link_${options.formId}_${options.formIndex}`;
    this.submitBoxId = `${this.submitSetting.name}_${options.formId}_${options.formIndex}_submit-box`;
    this.idArgee = `check-agreement_${options.formId}_${options.formIndex}`;
    this.nameInputArgee = `check-agree_${options.formId}`;
    this.idLabelAgree = `label_${options.formId}_${options.formIndex}`;
    this.agreementBoxId = `${this.submitSetting.name}_${options.formId}_${options.formIndex}_agreement-wrapper`;
    this.errorBoxId = `${this.submitSetting.name}_${options.formId}_${options.formIndex}_error-box`;
    this.errorBoxTextId = `${this.submitSetting.name}_${options.formId}_${options.formIndex}_error-box_text`;
    this.agreementLinkId = `agreement-link_${options.formId}`;
    this.labelId = `${this.submitSetting.name}_${options.formId}_${options.formIndex}_label`;
    this.listeners = [];
  }
  toHTML() {
    return `
      <div class="qform-field ${this.useAgreement === 0 ? "qform__mb-0" : ""}">
        <div class="qform-field__submit qform-field__agreement-wrapper" id="${this.agreementBoxId}">
          ${this.toHTMLCheck()}
        </div>
      </div>
    `;
  }
  toHTMLCheck() {
    if (this.useAgreement) {
      return `
        <div class="qform-field__submit_agree-box">
          ${
      // текст на согласие получения рекламных материалов
      this.agreementSettings.advLink ? `
              <input type="checkbox" class="qform-field__submit_agree-box__input" id="${this.adviseInputId}">
              <label for="${this.adviseInputId}" id="${this.adviseLabelId}">
                <span class="qform-field__submit_agree-box__text">${this.agreementSettings.advLink}</span>
              </label>
            ` : ""}

            <input type="checkbox" class="qform-field__submit_agree-box__input" id="${this.agreementInputId}">
            <label for="${this.agreementInputId}" id="${this.agreementLabelId}">
              <span class="qform-field__submit_agree-box__text">
                ${this.getLabelHTMLFromPieces(this.agreementSettings.dataLink)}
              </span>
            </label>

          <div class="qform-field__submit_agree-box__error-box" id="${this.errorBoxId}">
            <div class="qform-field__submit_agree-box__error-box_message" id="${this.errorBoxTextId}"></div>
          </div>
        </div>
      `;
    } else {
      return ``;
    }
  }
  getLabelHTMLFromPieces(labelPiecesArray) {
    return labelPiecesArray.reduce((sum, curr) => {
      let elem = "";
      if (curr.newLine) {
        sum += "<br/>";
      }
      if (curr.open) {
        if (curr.open === 1) {
          elem = `<a class="qform-field__submit_agree-box__link" data-link="${curr.link}">${curr.text}</a>`;
        } else if (curr.open === 2) {
          elem = `<a class="qform-field__submit_agree-box__link" href="${curr.link || "#"}" target="_blank">${curr.text}</a>`;
        }
      } else {
        elem = curr.text;
      }
      return sum + elem;
    }, "");
  }

  // async loadModule() {
  //   this.Transporter = await import(/* webpackChunkName: "transporter" */ '../../core/transporter').then((data) => {
  //     return data.transporter
  //   })
  // }

  async init() {
    let {
      disable = false
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // await this.loadModule()
    this.$agreementCheckbox = this.$root.$el.querySelector(`#${this.agreementInputId}`);
    this.$labelAgreementCheckbox = this.$root.$el.querySelector(`#${this.agreementLabelId}`);
    this.$adviseCheckbox = this.$root.$el.querySelector(`#${this.adviseInputId}`);
    this.$labelAdviseCheckbox = this.$root.$el.querySelector(`#${this.adviseLabelId}`);
    this.$errorBox = this.$root.$el.querySelector(`#${this.errorBoxId}`);
    this.$errorBoxText = this.$root.$el.querySelector(`#${this.errorBoxTextId}`);
    this.$agreementLink = this.$root.$el.querySelector(`#${this.agreementLinkId}`);
    this.$agreementCheckbox && (this.$agreementCheckbox.disabled = disable);
    if (this.useAgreement) {
      this.listeners = [{
        eventName: "change",
        method: "onChangeAgreementCheckbox",
        el: this.$agreementCheckbox
      }];
      if (this.$adviseCheckbox) {
        this.listeners.push({
          eventName: "change",
          method: "onChangeAdviseCheckbox",
          el: this.$adviseCheckbox
        });
      }
    }
    this.$root.$el.querySelectorAll("a[data-link]").forEach(el => {
      this.listeners.push({
        eventName: "click",
        method: "onClickAgreementLink",
        el
      });
    });
    if (this.useAgreement) {
      this.agreementBox = new AgreementBox(this.$root, {
        ...this.options,
        device: this.device
      });
      document.body.insertAdjacentHTML("beforeend", this.agreementBox.toHTML());
      await this.agreementBox.init();
    }
    this.$emit("Change:field", {});
    super.init();
  }
  onChangeAgreementCheckbox(event) {
    //исключаем подтверждение согласия при нажатии на ссылки в тексте
    if (event.target.tagName !== "A") {
      this.$emit("Change:field", {});
    }
  }
  onChangeAdviseCheckbox(event) {
    this.$emit("adviseCheckboxChanged", Number(event.target.checked));
  }
  validation() {
    let setMassageValid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    let valid = true;
    if (this.$agreementCheckbox) {
      if (this.useAgreement && !this.$agreementCheckbox.checked) {
        valid = false;
      }
      if (valid) {
        this.setMassageValid();
      } else {
        setMassageValid ? this.setMassageValid(this.messages.agreementError) : null;
      }
    }
    return valid;
  }
  getLabelHTML() {
    return `
    <p class="qform__form-label" id="${this.qformLabelId}">
      <a href="${this.captionLink}" id="${this.qformLabelLinkId}" target="_blank" rel="noopener noreferrer" title="Qform.io" class="qform__form-label__link">
      Создать форму
      </a>
      <span>Создано в конструкторе Qform.io</span>
    </p>
`;
  }
  setClassField() {
    if (this.disabledClass) {
      this.$emit("Change:field", {});
    }
  }
  onClickAgreementLink(event) {
    event.preventDefault();
    event.stopPropagation();
    this.agreementBox.getTextAgreement(event.target.dataset.link);
    this.agreementBox.showAgreementBox();
  }
}